(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/co-op-play-marketplace/assets/javascripts/retailer-game-card.js') >= 0) return;  svs.modules.push('/components/tipsen/co-op-play-marketplace/assets/javascripts/retailer-game-card.js');

'use strict';

const {
  useEffect,
  useRef
} = React;
const {
  ReactPaper: Paper
} = svs.ui;
const {
  RibbonBanner
} = svs.ui.ReactRibbon;
const {
  clx
} = svs.components.lbUtils;
const {
  formatDate
} = svs.components.lbUtils.helpers.formatDate;
const {
  getRetailUrl
} = svs.components.marketplace.helpers;
const {
  FractionPayment: FractionPaymentV1
} = svs.components.tipsen;
const {
  FractionPaymentV2
} = svs.components.marketplace.fractionPayment;
const {
  trackEvent
} = svs.components.analytics;
const {
  ActivatedDrawStatus
} = svs.components.marketplaceShared.coOpPlay.helpers.status;
const RetailerGameCard = _ref => {
  let {
    branding,
    game,
    onClick,
    product
  } = _ref;
  const cardRef = useRef(null);
  const hasNewFractionPaymentFlow = svs.core.detect.feature('ft-new-fraction-payment-flow');
  const FractionPayment = hasNewFractionPaymentFlow ? FractionPaymentV2 : FractionPaymentV1;
  const {
    activatedDrawId,
    activatedDrawStatus,
    buyStop,
    containerId,
    currentUserNumberOfShares,
    fractionPrice,
    groupId,
    maxFractions,
    name,
    ownerName,
    soldFractions
  } = game;
  const formatedDate = formatDate(buyStop, true, true, true);
  const formatedPrice = svs.utils.format.Currency(fractionPrice);
  const gameLink = "".concat(svs.core.urlMapping.get('marketplace')).concat(getRetailUrl(groupId, name, 'spel', containerId, activatedDrawId), "?products=").concat(product, "&returnUrl=").concat(location.href);
  useEffect(() => {
    var _document;
    const el = (_document = document) === null || _document === void 0 ? void 0 : _document.body;
    const handleClick = _ref2 => {
      var _cardRef$current;
      let {
        target
      } = _ref2;
      if ((_cardRef$current = cardRef.current) !== null && _cardRef$current !== void 0 && _cardRef$current.contains(target)) {
        onClick(groupId, activatedDrawId);
      }
    };
    el === null || el === void 0 || el.addEventListener('click', handleClick);
    return () => {
      el === null || el === void 0 || el.removeEventListener('click', handleClick);
    };
  }, [activatedDrawId, groupId, onClick]);
  let showFewSharesLeft = false;
  if (soldFractions !== maxFractions && activatedDrawStatus === ActivatedDrawStatus.OPEN) {
    if (maxFractions < 5) {
      showFewSharesLeft = maxFractions - soldFractions === 1;
    } else {
      showFewSharesLeft = soldFractions / maxFractions >= 0.8;
    }
  }
  return React.createElement(Paper, {
    branding: "sport",
    className: clx('game-card', {
      ["game-card-".concat(branding)]: branding,
      'game-card-has-shares': currentUserNumberOfShares > 0
    })
  }, React.createElement("div", {
    ref: cardRef
  }, React.createElement("a", {
    className: "game-card-header-link",
    href: gameLink
  }, React.createElement("div", {
    className: "game-card-header"
  }, React.createElement("div", {
    className: "game-card-title notranslate"
  }, name), React.createElement("div", {
    className: "game-card-contact notranslate"
  }, ownerName))), React.createElement("div", {
    className: "game-card-content"
  }, showFewSharesLeft && React.createElement(RibbonBanner, {
    direction: "right",
    size: "200"
  }, "F\xE5 kvar!"), React.createElement("div", {
    className: "game-card-andel"
  }, React.createElement("span", {
    className: "game-card-label"
  }, "Pris per andel"), React.createElement("span", {
    className: "game-card-value game-card-share-price notranslate"
  }, "".concat(formatedPrice, " kr"))), React.createElement("div", {
    className: "game-card-row game-card-borders"
  }, React.createElement("div", {
    className: "game-card-column game-card-buy-stop"
  }, React.createElement("div", {
    className: "game-card-label"
  }, "K\xF6pstopp"), React.createElement("div", {
    className: "game-card-value"
  }, formatedDate)), React.createElement("div", {
    className: "game-card-column game-card-shares-left"
  }, React.createElement("div", {
    className: "game-card-label"
  }, React.createElement("span", null, "Andelar"), currentUserNumberOfShares > 0 && React.createElement("span", {
    className: "game-card-shares-bought"
  }, "(dina)")), React.createElement("div", {
    className: "game-card-value"
  }, React.createElement("span", null, maxFractions), currentUserNumberOfShares > 0 && React.createElement("span", {
    className: "game-card-shares-bought"
  }, "(", currentUserNumberOfShares, ")"))))), React.createElement("div", {
    className: "game-card-footer"
  }, React.createElement(FractionPayment, {
    activatedDrawId: activatedDrawId,
    containerId: containerId,
    game: game,
    groupId: groupId,
    hasSnackbar: true
  }), React.createElement("a", {
    className: "btn btn-300 cta-goto-game",
    href: gameLink,
    onClick: () => {
      trackEvent({
        category: 'Andelsspel produktsida',
        action: 'CTA andelsspel',
        opt_label: 'Till spelet'
      });
    }
  }, React.createElement("span", null, "Till spelet")))));
};
const RetailerGamePropType = PropTypes.shape({
  activatedDrawId: PropTypes.number,
  activatedDrawStatus: PropTypes.number,
  buyStop: PropTypes.object,
  containerId: PropTypes.number,
  currentUserNumberOfShares: PropTypes.number,
  drawCloseTime: PropTypes.string,
  drawNumber: PropTypes.number,
  fractionPrice: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  groupId: PropTypes.number,
  maxFractions: PropTypes.number,
  name: PropTypes.string,
  ownerName: PropTypes.string,
  productId: PropTypes.number,
  productName: PropTypes.string,
  soldFractions: PropTypes.number,
  status: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  subProductId: PropTypes.number,
  templateId: PropTypes.number,
  totalBalance: PropTypes.number,
  wagerSerial: PropTypes.string
});
RetailerGameCard.defaultProps = {
  branding: 'sport'
};
setGlobal('svs.components.tipsen.RetailerGameCard', RetailerGameCard);
setGlobal('svs.components.tipsen.RetailerGamePropType', RetailerGamePropType);

 })(window);